import React, { useState, useEffect } from "react"
import MUIDataTable from "mui-datatables"
import CustomLoader from "../../common/Loader"
import { loadProjectPayment } from "../../../services/projectService"

const ProjectPayment = ({Project_ID}) => {
    const [loading, setLoading] = useState(true)
    const [columns, setColumns] = useState([])
    const [data, setData] = useState([])
    const [options, setOptions] = useState({
        download: true,
        downloadOptions: { filename: 'ThrivePayment.csv', separator: ','},
        print: false,
        selectableRowsHeader: false,
        selectableRows: 'none',
        pagination: true,
        rowsPerPageOptions: [10, 15, 30, 50, 100]
    })
    const [hasAccess, setHasAccess] = useState(false)

    useEffect(() => {
        loadProjectPayment(Project_ID)
        .then((response) => {
            if (typeof Object.values(response.data[0])[0] === "string" && Object.values(response.data[0])[0].includes("Error")) {
                setHasAccess(false)
            } else {
                let columns = Object.keys(response.data[0])
                columns = columns.map((col) => {
                    return {
                        name: col,
                        options: {
                            filter: ['PK_Value', 'FirstName', 'LastName', 'Street Address', 'City', 'State', 'Zip Code'].includes(col) ? false : true,
                            setCellHeaderProps: value => ({ style: { 'color': '#0061F2' } }),
                            setCellProps: value => ({ style: { 'color': '#687281', 'fontSize': 'medium', 'fontFamily': 'Metropolis' } })
                        }
                    }
                })
                setColumns(columns)
                let data = response.data.map((obj) => {
                    return Object.values(obj)
                })
                setData(data) 
                setHasAccess(true)
            }
            setLoading(false)
        })
        
    }, [])

    if (loading) {
        return <CustomLoader loading={loading} />
    } else {
        return <>
            <div className='card-body' key = {options} id='customDT'>
                {hasAccess ? <MUIDataTable
                    key={options}
                    title='Thrive Payment'
                    columns={columns}
                    data={data}
                    options={options}
                /> : <>No access. Please contact Thrive team if access is needed.</>}
            </div>
        </>
    }
}

export default ProjectPayment